@import "../../variables.scss";

.modalContainer {
  position: relative;
  background-color: white;
  height: 100%;
  width: 100%;
  z-index: 9999;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modalHeader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: white;
}

.modalTitleRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 40px 40px 40px;
}

.modalTitle {
  font-size: 24px;
  line-height: 32px;
  font-weight: 400;
  color: black;
  margin-bottom: 0;
}

.closeButtonRow {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px;
}

.closeButton {
  background: transparent;
  border: none;
  font-size: 24px;
  padding: 0;
}

.modalContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: white;
}

.modalContentWithSticky {
  overflow: hidden;
}

.stickyHeader {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.scrollableContent {
  overflow-y: auto;
  padding: 0 40px 40px 40px;
  flex: 1;

  @media (max-width: $size-md) {
    padding: 0 20px 20px 20px;
  }
}